export const isDateInPast = (timestamp: number): boolean => timestamp < Date.now();
